import useAxiosInstance from "../api/api-instanse";
import { useMemo } from "react";

export const useApi = () => {
  const { axiosInstance } = useAxiosInstance();

  return useMemo(() => {
    const get = (url, config = {}) => axiosInstance.get(url, config);
    const post = (url, data, config = {}) =>
      axiosInstance.post(url, data, config);
    const put = (url, data, config = {}) => axiosInstance.put(url, data, config);
    const del = (url, config = {}) => axiosInstance.delete(url, config);

    return { get, post, put, del };
  }, [axiosInstance]);
};
